import React from 'react'
import { List, ListItem } from 'Lib/List'
import { LOGOUT_LINK } from 'AccountsConstants/routes'
import { LOGOUT_HEADER } from 'AccountsConstants/language/account'
import { CLEVERTAP_EVENT_NAME, CLEVERTAP_PLATFORM } from 'AccountsConstants/clevertap'
import { navigateToExternalLink, triggerClevertap } from 'AccountsUtils'

const Logout = props => {
  const routePage = () => {
    const clevertapData = {
      'event type': 'sign out clicked',
      platform: CLEVERTAP_PLATFORM
    }
    triggerClevertap(CLEVERTAP_EVENT_NAME, clevertapData)
    navigateToExternalLink(LOGOUT_LINK)
  }

  const logoutList = (
    <List className="amt-20">
      <ListItem arrow={false} enableRipple={true}>
        <div className="flag h-48" onClick={routePage}>
          <div className="flag__flex">
            <h5 className="fs-17 lh-solid apr-10 c-red ta-c">{LOGOUT_HEADER}</h5>
          </div>
        </div>
      </ListItem>
    </List>
  )

  return <React.Fragment>{logoutList}</React.Fragment>
}

export default Logout
